module.exports = __webpack_public_path__ + "img/project10_12.jpg.011e2e0f.webp";